<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <slot name="icon_on" v-bind={on}>
        <div v-on="on" class="circleHelp2">?</div>
      </slot>
    </template>
    <fs1-span>
      <slot>
        <template v-if="typeof text == 'string'">
          {{ text }}
        </template>
        <template v-if="typeof text == 'object'">
          <div v-for="(v,i) in text" :key="i">{{v}}</div>
        </template>
        </slot>
    </fs1-span>
  </v-tooltip>
</template>

<script>
export default { props:['text'] };
</script>
